module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/ClanLandingReserves/images/new-reserve-hover-sm.42ac3291.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/ClanLandingReserves/images/new-reserve-hover-sm.png
// module id = 2931
// module chunks = 11